import React from 'react'

type TabsProps = {
  tabs: string[]
  selectedIndex: number
  onSelect: (index: number) => void
  headerClassName?: string
  idPrefix?: string
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  selectedIndex,
  onSelect,
  headerClassName,
  idPrefix = 'tab',
}) => {
  return (
    <div id="schedule-tabs" className="tabs">
      <div className={`tabs-header ${headerClassName ?? ''}`.trim()} role="tablist">
        {tabs.map((label, index) => {
          const isActive = index === selectedIndex
          const tabId = `${idPrefix}-${index}`
          const panelId = `panel-${index}`
          return (
            <button
              key={index}
              className={`tab-trigger ${isActive ? 'active' : ''} group`.trim()}
              role="tab"
              aria-selected={isActive}
              aria-controls={panelId}
              id={tabId}
              tabIndex={isActive ? 0 : -1}
              onClick={() => onSelect(index)}
            >
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default Tabs


